import {booleanAttribute, ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'

import {RouterLink} from '@angular/router'

@Component({
  selector: 'cft-list-element',
  templateUrl: './list-element.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule, RouterLink],
  standalone: true,
})
export class ListElementComponent {
  @Input() label!: string
  @Input() link!: string
  @Input({transform: booleanAttribute}) truncateLabel = false

  protected readonly icon = faCaretRight
}
